// import React, { useEffect, useRef, useState } from 'react';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import { Grid } from '@mui/material';

// const MuiResponsivePhoneInput = ({ setMobile }) => {
//   const [phone, setPhone] = useState('');
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const containerRef = useRef(null);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       const dropdown = document.querySelector('.country-list');
//       if (dropdown && dropdown.offsetParent !== null) {
//         setIsDropdownOpen(true);
//       } else {
//         setIsDropdownOpen(false);
//       }
//     }, 200); // Checks every 200ms

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <Grid
//       item
//       xs={12}
//       sm={12}
//       md={12}
//       lg={11}
//       sx={{
//         overflow: 'visible',
//         transition: 'height 0.5s ease',
//         minHeight: isDropdownOpen ? '35vh' : 'auto',
//       }}
//       ref={containerRef}
//     >
//       <PhoneInput
//         country={'us'}
//         enableSearch={true}
//         value={phone}
//         onChange={(value, data) => {
//           setPhone(value);
//           setMobile({
//             full: value,
//             dialCode: data.dialCode,
//             number: value.replace(`${data.dialCode}`, ''),
//           });
//         }}
//         inputStyle={{
//           width: '100%',
//           fontSize: '1rem',
//         }}
//         dropdownStyle={{
//           width: '30vw',
//           zIndex: 9999,
//         }}
//         buttonStyle={{
//           width: '50px', // increase flag button width

//         }}
//         searchStyle={{
//           width: '25vw',
//           zIndex: 9999,
//         }}
//         inputProps={{
//           name: 'phone',
//           required: true,
//           autoFocus: true,
//         }}
//       />
//     </Grid>
//   );
// };

// export default MuiResponsivePhoneInput;

import React, { useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Grid } from "@mui/material";

const MuiResponsivePhoneInput = ({ setMobile, error = false }) => {
  const [phone, setPhone] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [detectedCountry, setDetectedCountry] = useState("za");
  const containerRef = useRef(null);

  // Auto detect country via IP
  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();
        if (data && data.country) {
          setDetectedCountry(data.country.toLowerCase()); // 'in', 'us', etc.
        }
      } catch (error) {
        console.error("Failed to detect country, defaulting to US.", error);
        setDetectedCountry("za");
      }
    };
    fetchCountry();
  }, []);

  // Monitor dropdown open state for responsiveness
  useEffect(() => {
    const interval = setInterval(() => {
      const dropdown = document.querySelector(".country-list");
      if (dropdown && dropdown.offsetParent !== null) {
        setIsDropdownOpen(true);
      } else {
        setIsDropdownOpen(false);
      }
    }, 200);

    return () => clearInterval(interval);
  }, []);

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      sx={{
        overflow: "visible",
        transition: "height 0.5s ease",
        minHeight: isDropdownOpen ? "38vh" : "auto",
      }}
      ref={containerRef}
    >
      <PhoneInput
        country={detectedCountry}
        enableSearch={true}
        value={phone}
        containerClass="custom-phone-input"
        onChange={(value, data) => {
          setPhone(value);
          setMobile({
            full: value,
            dialCode: data.dialCode,
            number: value.replace(`${data.dialCode}`, ""),
          });
        }}
        inputStyle={{
          width: "100%",
          borderRadius: "6px",
          height: "2.4rem",
          borderColor: error ? "#dc2626" : "#d1d5db",
          background: error ? "#fef2f2" : "#fff",
        }}
        // dropdownStyle={{
        //   width: '30vw',
        //   zIndex: 9999,
        // }}
        buttonStyle={{
          width: "50px",
          borderRadius: "6px 0 0 6px",
          borderColor: error ? "#dc2626" : "#d1d5db",
          background: error ? "#fef2f2" : "#fff",
        }}
        searchStyle={{
          zIndex: 9999,
        }}
        inputProps={{
          name: "phone",
          required: true,
          // autoFocus: true,
        }}
      />
    </Grid>
  );
};

export default MuiResponsivePhoneInput;
